<template>
  <div class="form-group-choose">
    <div v-if="!hideButton" class="member-btn">
      <div v-if="!isText" class="open" @click="openD">
        <slot>
          <el-button size="small" type="primary">{{ title }}</el-button>
        </slot>
      </div>
      <div class="member-list" :class="{'has-user': departMentTag.length > 0 && !isText}">
        <el-tag
          v-for="(item, index) in departMentTag"
          :key="index + 'group'"
          :closable="!isText"
          type="info"
          style="margin-right: 8px; margin-bottom: 8px"
          @close="deleteDepart(item)"
        >
          <span>
            {{ item.value }}
          </span>
        </el-tag>
      </div>
    </div>
    <el-dialog
      ref="dialog"
      class="custom-checkbox-group"
      :title="title"
      :append-to-body="true"
      :visible.sync="visibleDialog"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :before-close="cancelVisiable"
      width="640px"
    >
      <div class="wc-staff-range">
        <div class="left">
          <span v-if="disabledDeptsCom.length" class="title">{{ subTitle }}</span>
          <div class="scroll">
            <CustomTree
              ref="tree"
              v-model="departValue"
              :data="allDepart"
              node-key="id"
              :check-strictly="strictly"
              :expand-on-click-node="false"
              :props="defaultProps"
              :default-expanded-keys="defaultExpandedKeys"
              :department-list.sync="departmentList"
              :childern-follow-parent="childernFollowParent"
              :show-range="showRange"
            />
          </div>
        </div>
        <div class="right">
          <span v-if="disabledDeptsCom.length" class="title">{{ thrTitle }}</span>
          <div class="scroll">
            <div v-for="(item, index) in departmentList" :key="index" class="item item-flex">
              <div>
                <span class="ml-5">{{ item.value }}</span>
              </div>
              <span class="flex-left">
                <i class="el-icon-close" @click="item.del(() => {})" />
              </span>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" class="line-btn" @click="cancelVisiable">取 消</el-button>
        <el-button size="small" type="primary" :loading="btnLoading" @click="setDepartmentCheckBefore">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { getAllDepartmentTree } from '@/views/processManage/api'
import { getDepartmentTree } from '@/api/common'
import cloneDeep from 'lodash/cloneDeep'
import { mapState } from 'vuex'
// eslint-disable-next-line no-unused-vars
const changeDisable = (list = [], disable) => {
  list.forEach(v => {
    if (disable?.includes(v.id)) {
      v.disabled = true
    } else {
      v.disabled = false
    }
    if (v.childList) {
      changeDisable(v.childList, disable)
    }
  })
  return JSON.parse(JSON.stringify(list))
}
const changeVisible = (list = [], vasibaleList = []) => {
  list.forEach((v) => {
    if (vasibaleList.includes(v.id)) {
      v.visible = true
    } else {
      v.visible = false
    }
    if (v.childList) {
      changeVisible(v.childList, vasibaleList)
    }
  })
  return JSON.parse(JSON.stringify(list))
}
const changeShow = (list = [], canShowlist = []) => {
  list.forEach((v) => {
    if (!canShowlist.includes(v.id)) {
      v.notShow = true
    }
    if (v.childList) {
      changeShow(v.childList, canShowlist)
    }
  })
  return JSON.parse(JSON.stringify(list))
}
const getAllId = (list = [], key = 'id', r = [], eq_key = '', eq_value = '') => {
  list.forEach((v) => {
    if (eq_key) {
      if (v[eq_key] === eq_value) {
        r.push(v[key])
      }
    } else {
      r.push(v[key])
    }
    if (v.childList) {
      getAllId(v.childList, key, r, eq_key, eq_value)
    }
  })
  return JSON.parse(JSON.stringify(r))
}
export default {
  name: 'DeparTree',
  props: {
    strictly: {
      type: Boolean,
      default: true
    },
    hasSubmit: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => []
    },
    // 分支中文描述
    info: {
      type: String,
      default: ''
    },
    isText: {
      type: Boolean, // 只展示内容
      default: false
    },
    showUsers: {
      type: Boolean, // 展示tag标签
      default: false
    },
    thrTitle: {
      type: String,
      default: '已选范围'
    },
    subTitle: {
      type: String,
      default: '当前可选范围'
    },
    title: {
      type: String,
      default: () => '选择部门'
    },
    commitMes: {
      type: String,
      default: () => ''
    },
    // 禁用部门
    disabledDepts: {
      type: Array,
      default: () => []
    },
    showBtnLoading: {
      type: Boolean,
      default: false
    },
    // 隐藏按钮和标签
    hideButton: {
      type: Boolean,
      default: false
    },
    childernFollowParent: {
      type: Boolean,
      default: false
    },
    // 可见范围处理
    showRange: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      allDepart: [],
      departValue: [],
      staffList: [],
      showList: [],
      departmentList: [],
      departMentTag: [],
      visibleDialog: false,
      defaultProps: {
        children: 'childList',
        label: 'value',
        disabled: (data) => { return data.type === 1 && !data.visible && this.showRange }
      },
      btnLoading: false
    }
  },
  computed: {
    ...mapState('async', ['departMentTree']),
    defaultExpandedKeys() {
      return this.staffList.map(item => item.id)
    },
    // 控制部分部门节点禁用
    disabledDeptsCom() {
      return changeDisable(this.staffList, this.disabledDepts)
    }
  },
  watch: {
    visibleDialog(val) {
      if (val) {
        this.init()
      }
    }
  },
  mounted() {
    this.$refs.dialog.rendered = true
    this.staffList = this.departMentTree ? cloneDeep(this.departMentTree) : []
    // if (this.staffList.length > 0) {
    //   this.init()
    // }
    // console.log(
    //   this.staffList, 'this.staffList'
    // )
    this.getStaffList()
  },
  methods: {
    // 打开dialog
    openD() {
      this.visibleDialog = true
      this.getStaffList()
    },
    // 获取部门
    async getStaffList() {
      if (this.staffList.length < 1) {
        const { code, data } = await getDepartmentTree(JSON.stringify({}))
        // eslint-disable-next-line eqeqeq
        if (code === 200) {
          this.staffList = data
        }
      }
      if (this.allDepart.length < 1) {
        this.getAllDepart()
      }
    },
    deleteDepart(departMentTag) {
      const deletItemIndex = this.departmentList.findIndex((item) => item.id === departMentTag.id)
      console.log('deleteDepart deletItemIndex', deletItemIndex, departMentTag, this.departmentList)
      if (deletItemIndex !== -1) {
        this.departmentList[deletItemIndex].del && this.departmentList[deletItemIndex].del(() => {
          // this.departmentList.splice(deletItemIndex, 1)
          this.$emit('input', this.departValue)
          this.departMentTag = cloneDeep(this.departmentList)
          this.sendInfo()
          this.$emit('validateProp')
        })
      }
      // tagDelete && tagDelete(() => {
      //   this.submitAuth(false)
      // })
    },
    removeDepartment(del) {
      del && del(() => {
        this.$emit('input', this.departValue)
        this.sendInfo()
      })
    },
    async getAllDepart() {
      if (this.allDepart.length > 0) {
        return
      }
      const res = await getAllDepartmentTree()
      if (res.code === 200 && res.data) {
        const vasibaleList = getAllId(this.staffList, 'id', [], 'visible', true)
        const allDepart = changeVisible(changeDisable(res.data, this.disabledDepts), this.showRange ? vasibaleList : [])
        const canShowList = getAllId(this.staffList)
        if (this.showRange) {
          this.allDepart = changeShow(allDepart, canShowList)
        } else {
          this.allDepart = allDepart
        }
        this.init()
      }
    },
    // 选中回显
    async init() {
      const arr = []
      // this.departValue.forEach(item => {
      //   arr.push({ id: item })
      // })
      this.departValue = cloneDeep(this.value)
      this.value.forEach(item => {
        arr.push({ id: item })
      })
      this.$nextTick(async() => {
        this.$refs.tree && this.$refs.tree.init({
          departmentList: arr
        }, () => {
          this.departMentTag = this.departmentList
          this.showList = cloneDeep(this.departmentList)
        })
      })
    },
    // 关闭弹窗
    cancelVisiable() {
      this.clearSearch()
      this.resetAuth()
      this.visibleDialog = false
    },
    resetAuth() {
      // 取消要将数据至会原位
      this.departValue = cloneDeep(this.value)
      const departmentList = this.departValue.map((item) => {
        return { id: item }
      })
      this.$nextTick(() => {
        this.init({ departmentList }, false, () => {
          this.departMentTag = this.departmentList
        })
      })
    },
    setDepartmentCheckBefore() {
      const l = this.departValue.length
      if (l < 1) {
        this.$message.error('至少选择1个部门')
        return
      }
      if (this.commitMes) {
        this.$confirm(this.commitMes, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.setDepartmentCheck()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      } else {
        this.setDepartmentCheck()
      }
    },
    // 设置部门
    async setDepartmentCheck() {
      await this.$nextTick()
      this.departMentTag = cloneDeep(this.departmentList)
      this.$emit('input', this.departValue)
      this.$emit('validateProp')
      this.sendInfo()
      if (this.hasSubmit) {
        if (this.showBtnLoading) {
          this.btnLoading = true
          this.$emit('submit', this.departmentList, () => {
            this.clearSearch()
            this.btnLoading = false
            this.visibleDialog = false
          })
          return null
        } else {
          this.$emit('submit', this.departmentList)
        }
      }
      this.clearSearch()
      this.visibleDialog = false
    },
    // 生成分支回显数据
    sendInfo() {
      const infoList = this.departmentList.map((item) => {
        return item.value
      })
      if (infoList.length > 0) {
        this.$emit('update:info', infoList.join('、'))
      } else {
        this.$emit('update:info', '')
      }
    },
    clearSearch() {
      this.$refs.tree && this.$refs.tree.clearSearch()
    }
  }
}
</script>

<style scoped lang="scss">
$wit-primary: "#409EFF";
.form-group-choose {
  .member-btn {
    .open {
      display: inline-block;
    }
    .member-list {
      &.has-user {
        padding-top: 16px;
      }
      // padding: 10px 0px;
      display: flex;
      flex-wrap: wrap;
      max-height: 200px;
      overflow-y: auto;
      /deep/img {
        width: 24px;
        height: 24px;
        object-fit: fill;
      }
      /deep/.el-tag__close {
      color: #333;
      }
      /deep/.el-tag {
        color: #333;
        cursor: pointer;
        img {
          width: 24px;
          height: 24px;
          border-radius: 24px;
          vertical-align: middle;
          margin-right: 8px;
        }
        span {
          // line-height: 40px;
          display: inline-block;
          vertical-align: top;
        }
        &:hover {
          color: $wit-primary;
          background-color: $wit-opacity9;
          .el-tag__close {
            color: $wit-primary;
            background-color: $wit-opacity6;
          }
        }
      }
    }
  }
}
.custom-checkbox-group {
  /deep/ .el-dialog__body {
    border-top: 1px solid #eee;
  }
  .wc-staff-range {
    width: 100%;
    display: flex;
    height: 500px;
    /deep/ .svg-icon {
      &:hover {
        color: $wit-primary !important;
      }
    }
    .left {
      flex: 1;
      padding-top: 16px;
      height: 100%;
      display: flex;
      flex-direction: column;
      /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: $wit-primary;
        border-color: $wit-primary;
      }
    }
    .right {
      flex: 1;
      padding-top: 16px;
      padding-left: 16px;
      height: 100%;
      display: flex;
      flex-direction: column;
      border-left: 1px solid #eee;
      .title{
        margin-bottom: 6px;
      }
      img {
        width: 24px;
        height: 24px;
        margin-right: 5px;
      }
    }
    .title {
      height: 30px;
      line-height: 30px;
      text-align: left;
    }

    .item {
      border-radius: 4px;
      &:hover {
        background: #f5f7fa;
      }
    }

    .item-flex {
      padding: 10px 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      div {
        flex: 5;
        display: flex;
        align-items: center;
      }
      .flex-left {
        flex: 1;
        display: flex;
        justify-content: flex-end;
      }
    }
    .scroll {
      flex: 1;
      height: 0;
      overflow-y: auto;
      margin-right: 2px;
      &::-webkit-scrollbar {
        width: 0 !important;
      }
    }
  }
  /deep/ .el-dialog {
    border-radius: 12px;
    margin-top: 10vh !important;
    .el-checkbox,
    .el-checkbox__input {
      display: inline-block;
      position: relative;
      white-space: nowrap;
    }
  }
  /deep/ .el-dialog__title {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
  }
  /deep/ .el-dialog__header {
    padding: 32px 32px 22px 32px;
    .el-dialog__headerbtn{
      top: 32px;
    }
  }
  /deep/ .el-dialog__footer {
    padding: 32px;
  }
  /deep/ .el-dialog__close {
    font-size: 20px;
    color: #000;
    font-weight: 500;
    right: 32px;
  }

  /deep/ .el-dialog__body {
    padding: 0px 32px;
    display: flex;
    .el-tree-node{
      .el-tree-node__content{
        min-height: 48px;
      }
      .el-tree-node__children{
        .el-tree-node__content{
          height: auto;
          min-height: 36px;
          padding: 2px 0px;
        }
      }
      .custom-tree-node {
        display: flex;
        align-items: center;
        i {
          white-space: normal;
        }
      }
    }
    &:after {
      visibility: hidden;
      display: block;
      font-size: 0;
      content: " ";
      clear: both;
      height: 0;
    }
  }
}
// .el-button {
//   padding: 8px 12px;
// }
body.sys-deep-style {
  .custom-checkbox-group {
    .wc-staff-range {
      .item:hover {
        background: #343845;
      }
    }
  }
}
</style>
